module.exports = __webpack_public_path__ + "static/media/external_env_4_media_9.19567314.webp";